import React from "react";
import { useClientController } from "../useClientController";
import { EntityAvatar } from "@/components/core/EntityAvatar";

interface ClientAvatarProps {
  className?: string;
  showLabel?: boolean;
}

export const ClientAvatar: React.FC<ClientAvatarProps> = ({
  className,
  showLabel = true,
}) => {
  const { client } = useClientController();

  return (
    <EntityAvatar
      entityType="client"
      name={client?.name}
      className={className}
      showLabel={showLabel}
    />
  );
};
